import MessageBox from "sap/m/MessageBox";
import Util from "ips/ac/util/Util";
import History from "sap/ui/core/routing/History";

export default class Navigation {
  private static changed: boolean
  private static changesReset?: Function

  public static navTo(route: string, data?: object, replace = false) {
    const oDataModel = Util.getODataModel();

    const fnCallback = () => {
      Util.getComponent().getRouter().navTo(route, data, replace);
    };

    if (oDataModel.hasPendingChanges() || Navigation.changed) {
      Navigation._confirmNavigation(fnCallback);
      return;
    }

    fnCallback();
  }

  public static navBack() {
    let oHistory = History.getInstance();
    let sPreviousHash = oHistory.getPreviousHash();

    if (sPreviousHash !== undefined) {
      window.history.go(-1);
    } else {
      this.navTo("events", {}, true);
    }
  }

  public static setChanged(resetFunction: Function) {
    Navigation.changed = true
    Navigation.changesReset = resetFunction
  }

  public static unsetChanged() {
    Navigation.changed = false
    Navigation.changesReset = null
  }

  private static _confirmNavigation(callback: Function) {
    const question = Util.getText("warningConfirm");
    const title = Util.getText("warning");
    const oDataModel = Util.getODataModel();

    MessageBox.show(question, {
      icon: MessageBox.Icon.WARNING,
      title: title,
      actions: [MessageBox.Action.OK, MessageBox.Action.CANCEL],
      onClose: function(oAction) {
        if (oAction === MessageBox.Action.OK) {
          oDataModel.resetChanges();
          if(Navigation.changesReset) {
            Navigation.changesReset()
          }
          Navigation.changed = false;
          callback();
        }
      },
    });
  }
}